import React, {
  useState,
  useEffect
} from "react";

import api from "../../api";

import {
  useNavigate,
  useParams
} from "react-router-dom";

import {
  motion,
  AnimatePresence
} from "framer-motion";

function ClientEditForm() {

  const { id } =
    useParams();

  const navigate =
    useNavigate();

  const [form, setForm] =
    useState({
      nom: "",
      post_nom: "",
      prenom: "",
      telephone: "",
      email: "",
      nationalite: "",
      sexe: "",
      adresse: "",
      type_piece: "",
      numero_piece: ""
    });

  const [showToast, setShowToast] =
    useState(false);

  // =====================
  // FETCH
  // =====================

  useEffect(() => {

    api
      .get(`/clients/${id}`)
      .then((res) =>
        setForm(
          res.data
        )
      )
      .catch((err) =>
        console.error(err)
      );

  }, [id]);

  // =====================
  // CHANGE
  // =====================

  const handleChange =
    (e) => {

      const {
        name,
        value
      } = e.target;

      if (
        name ===
        "telephone"
      ) {

        let cleaned =
          value.replace(
            /[^0-9+]/g,
            ""
          );

        if (
          cleaned.includes(
            "+"
          )
        ) {

          cleaned =
            "+" +
            cleaned.replace(
              /\+/g,
              ""
            );
        }

        setForm({
          ...form,
          [name]:
            cleaned
        });

        return;
      }

      setForm({
        ...form,
        [name]: value
      });
    };

  // =====================
  // SUBMIT
  // =====================

  const handleSubmit =
    async (e) => {

      e.preventDefault();

      if (
        !window.confirm(
          "Confirmer les modifications ?"
        )
      ) {
        return;
      }

      await api.put(
        `/clients/${id}`,
        form
      );

      setShowToast(
        true
      );

      setTimeout(
        () => {

          setShowToast(
            false
          );

          navigate(
            "/clients"
          );

        },
        2500
      );
    };

  // =====================
  // RENDER
  // =====================

  return (
    <div className="min-h-[100dvh] bg-gray-100 flex justify-center items-start py-4 md:py-10 px-3">

      {/* TOAST */}
      <AnimatePresence>

        {showToast && (

          <motion.div
            initial={{
              opacity: 0,
              y: -20
            }}
            animate={{
              opacity: 1,
              y: 0
            }}
            exit={{
              opacity: 0
            }}
            className="fixed top-5 right-3 md:right-5 bg-green-600 text-white px-5 py-3 rounded-2xl shadow-2xl z-50 text-sm"
          >
            ✅ Client modifié avec succès
          </motion.div>

        )}

      </AnimatePresence>

      <div className="w-full max-w-4xl space-y-5">

        {/* HEADER */}
        <div className="flex flex-col md:flex-row justify-between md:items-center gap-3">

          <h2 className="text-2xl md:text-3xl font-bold">
            Modifier client
          </h2>

          <button
            onClick={() =>
              navigate(
                "/clients"
              )
            }
            className="bg-gray-200 hover:bg-gray-300 transition px-4 py-3 rounded-xl text-sm"
          >
            ← Retour liste
          </button>

        </div>

        {/* FORM */}
        <div className="bg-white rounded-2xl shadow p-4 md:p-6">

          <form
            onSubmit={
              handleSubmit
            }
            className="space-y-6"
          >

            {/* IDENTITE */}
            <div>

              <h3 className="text-lg font-semibold mb-4 text-gray-700">
                Informations personnelles
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

                <input
                  name="nom"
                  required
                  value={
                    form.nom
                  }
                  onChange={
                    handleChange
                  }
                  placeholder="Nom"
                  className="border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-400"
                />

                <input
                  name="post_nom"
                  required
                  value={
                    form.post_nom
                  }
                  onChange={
                    handleChange
                  }
                  placeholder="Post-nom"
                  className="border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-400"
                />

                <input
                  name="prenom"
                  required
                  value={
                    form.prenom
                  }
                  onChange={
                    handleChange
                  }
                  placeholder="Prénom"
                  className="border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-400"
                />

              </div>

            </div>

            {/* CONTACT */}
            <div>

              <h3 className="text-lg font-semibold mb-4 text-gray-700">
                Contact
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                <input
                  name="telephone"
                  required
                  value={
                    form.telephone
                  }
                  onChange={
                    handleChange
                  }
                  placeholder="+243..."
                  className="border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-400"
                />

                <input
                  type="email"
                  name="email"
                  required
                  value={form.email || ""}
                  onChange={handleChange}
                  placeholder="Email"
                  className="border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-400"
                />

                <input
                  name="nationalite"
                  required
                  value={
                    form.nationalite
                  }
                  onChange={
                    handleChange
                  }
                  placeholder="Nationalité"
                  className="border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-400"
                />

                <select
                  name="sexe"
                  required
                  value={
                    form.sexe
                  }
                  onChange={
                    handleChange
                  }
                  className="border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-400"
                >

                  <option value="">
                    Sexe
                  </option>

                  <option value="Masculin">
                    Masculin
                  </option>

                  <option value="Féminin">
                    Féminin
                  </option>

                </select>

                <input
                  name="adresse"
                  required
                  value={
                    form.adresse
                  }
                  onChange={
                    handleChange
                  }
                  placeholder="Adresse"
                  className="border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-400 md:col-span-2"
                />

              </div>

            </div>

            {/* PIECE */}
            <div>

              <h3 className="text-lg font-semibold mb-4 text-gray-700">
                Pièce d'identité
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                <select
                  name="type_piece"
                  required
                  value={form.type_piece}
                  onChange={handleChange}
                  className="border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-400"
                >
                  <option value="">
                    Type de pièce
                  </option>

                  <option value="Carte d'identité">
                    Carte d'identité
                  </option>

                  <option value="Carte d'électeur">
                    Carte d'électeur
                  </option>

                  <option value="Passeport">
                    Passeport
                  </option>

                  <option value="Permis de conduire">
                    Permis de conduire
                  </option>

                  <option value="Carte de résident">
                    Carte de résident
                  </option>

                  <option value="Autre">
                    Autre
                  </option>
                </select>

                <input
                  name="numero_piece"
                  required
                  value={
                    form.numero_piece
                  }
                  onChange={
                    handleChange
                  }
                  placeholder="Numéro pièce"
                  className="border rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-400"
                />

              </div>

            </div>

            {/* ACTIONS */}
            <div className="flex flex-col md:flex-row gap-3 pt-2">

              <button
                type="button"
                onClick={() =>
                  navigate(
                    "/clients"
                  )
                }
                className="flex-1 bg-gray-200 hover:bg-gray-300 transition py-3 rounded-xl font-semibold"
              >
                Annuler
              </button>

              <button
                type="submit"
                className="flex-1 bg-blue-600 hover:bg-blue-700 transition text-white py-3 rounded-xl font-semibold"
              >
                Enregistrer
              </button>

            </div>

          </form>

        </div>

      </div>

    </div>
  );
}

export default ClientEditForm;